import { InboundEmail, OutboundEmail } from "@zickko/shared";

type Props = {
  email: InboundEmail | OutboundEmail;
  onSelectEmail: () => void;
};

export const TrashEmailListItemWidget = (props: Props) => {
  const { email, onSelectEmail } = props;
  const senderName = (email as InboundEmail).headers?.from?.name || (email as OutboundEmail).from || "Unknown Sender";
  const subject = (email as InboundEmail).headers?.subject || (email as OutboundEmail).subject || "No Subject";
  const snippet = (email as InboundEmail)?.previewSnippet || "No preview available";

  const handleEmailClick = () => {
    onSelectEmail();
  };

  return (
    <div className="email-list-item-widget-container" onClick={handleEmailClick}>
      <div className="email-list-item-widget">
        <div className="heading">
          <div className="sender">{senderName}</div>
          <div className="time">9 months ago</div>
        </div>
        <div className="subject">{subject}</div>
        <div className="mail-snippet">{snippet} . . . </div>
        <div className="tags">
          <div className="meeting-tag">meeting</div>
          <div className="work-tag">work</div>
          <div className="important-tag">important</div>
        </div>
      </div>
    </div>
  );
};
